import { createContext, useContext, useState, useCallback, useEffect } from "react";

const STR = {
  "nav.home": { en: "HOME", hi: "होम", pa: "ਹੋਮ" },
  "nav.menu": { en: "MENU", hi: "मेन्यू", pa: "ਮੀਨੂ" },
  "nav.passport": { en: "PASSPORT", hi: "पासपोर्ट", pa: "ਪਾਸਪੋਰਟ" },
  "nav.order": { en: "ORDER", hi: "ऑर्डर", pa: "ਆਰਡਰ" },
  "nav.brands": { en: "BRANDS", hi: "ब्रांड्स", pa: "ਬ੍ਰਾਂਡ" },
  "nav.arcade": { en: "ARCADE", hi: "आर्केड", pa: "ਆਰਕੇਡ" },
  "home.h1": { en: "A Journey Through Punjabi Food", hi: "पंजाबी खाने का सफ़र", pa: "ਪੰਜਾਬੀ ਖਾਣੇ ਦਾ ਸਫ਼ਰ" },
  "home.sub": {
    en: "Browse the menu normally—or open your Urban Passport to discover the people, places and stories behind Punjab's food.",
    hi: "मेन्यू आराम से देखें — या अपना Urban Passport खोलें और पंजाब के खाने के पीछे के लोग, जगहें और कहानियाँ जानें।",
    pa: "ਮੀਨੂ ਆਰਾਮ ਨਾਲ ਵੇਖੋ — ਜਾਂ ਆਪਣਾ Urban Passport ਖੋਲ੍ਹੋ ਤੇ ਪੰਜਾਬ ਦੇ ਖਾਣੇ ਪਿੱਛੇ ਦੇ ਲੋਕ, ਥਾਵਾਂ ਤੇ ਕਹਾਣੀਆਂ ਜਾਣੋ।",
  },
  "home.browse": { en: "BROWSE THE MENU", hi: "मेन्यू देखें", pa: "ਮੀਨੂ ਵੇਖੋ" },
  "home.arcadeTab": { en: "THE URBAN ARCADE", hi: "अर्बन आर्केड", pa: "ਅਰਬਨ ਆਰਕੇਡ" },
  "home.play": { en: "PLAY & EARN", hi: "खेलें और कमाएँ", pa: "ਖੇਡੋ ਤੇ ਕਮਾਓ" },
  "home.choiceMenuTitle": { en: "Browse the Menu", hi: "मेन्यू देखें", pa: "ਮੀਨੂ ਵੇਖੋ" },
  "home.choiceMenuDesc": {
    en: "Full menu, prices and photos — order the normal way.",
    hi: "पूरा मेन्यू, दाम और फ़ोटो — आम तरीक़े से ऑर्डर करें।",
    pa: "ਪੂਰਾ ਮੀਨੂ, ਕੀਮਤਾਂ ਤੇ ਫ਼ੋਟੋਆਂ — ਆਮ ਤਰੀਕੇ ਨਾਲ ਆਰਡਰ ਕਰੋ।",
  },
  "home.choicePassportDesc": {
    en: "Stories, challenges and rewards while you eat.",
    hi: "खाते-खाते कहानियाँ, चैलेंज और इनाम।",
    pa: "ਖਾਂਦੇ-ਖਾਂਦੇ ਕਹਾਣੀਆਂ, ਚੈਲੰਜ ਤੇ ਇਨਾਮ।",
  },
  "home.menuKicker": { en: "The menu", hi: "मेन्यू", pa: "ਮੀਨੂ" },
  "home.menuTitle": { en: "Browse by category", hi: "कैटेगरी से देखें", pa: "ਕੈਟਾਗਰੀ ਨਾਲ ਵੇਖੋ" },
  "home.lovedKicker": { en: "Most loved", hi: "सबसे पसंदीदा", pa: "ਸਭ ਤੋਂ ਪਸੰਦੀਦਾ" },
  "home.lovedTitle": { en: "Featured dishes", hi: "ख़ास डिशेज़", pa: "ਖ਼ਾਸ ਡਿਸ਼ਾਂ" },
  "home.storyKicker": { en: "Food stories", hi: "खाने की कहानियाँ", pa: "ਖਾਣੇ ਦੀਆਂ ਕਹਾਣੀਆਂ" },
  "home.storyTitle": { en: "Every dish has a story", hi: "हर डिश की एक कहानी है", pa: "ਹਰ ਡਿਸ਼ ਦੀ ਇੱਕ ਕਹਾਣੀ ਹੈ" },
  "home.readStory": { en: "READ THE STORY →", hi: "कहानी पढ़ें →", pa: "ਕਹਾਣੀ ਪੜ੍ਹੋ →" },
  "home.inviteTitle": { en: "Your Urban Passport", hi: "आपका Urban Passport", pa: "ਤੁਹਾਡਾ Urban Passport" },
  "home.inviteDesc": {
    en: "Explore Punjab's food stories, test your knowledge and earn rewards.",
    hi: "पंजाब के खाने की कहानियाँ जानें, अपना ज्ञान परखें और इनाम कमाएँ।",
    pa: "ਪੰਜਾਬ ਦੇ ਖਾਣੇ ਦੀਆਂ ਕਹਾਣੀਆਂ ਜਾਣੋ, ਆਪਣਾ ਗਿਆਨ ਪਰਖੋ ਤੇ ਇਨਾਮ ਕਮਾਓ।",
  },
  "home.startAdventure": { en: "START PASSPORT ADVENTURE", hi: "पासपोर्ट सफ़र शुरू करें", pa: "ਪਾਸਪੋਰਟ ਸਫ਼ਰ ਸ਼ੁਰੂ ਕਰੋ" },
  "home.visitUs": { en: "VISIT US", hi: "हमसे मिलें", pa: "ਸਾਨੂੰ ਮਿਲੋ" },
  "home.mapsLine": { en: "MAPS, HOURS & PHONE →", hi: "नक्शा, समय और फ़ोन →", pa: "ਨਕਸ਼ਾ, ਸਮਾਂ ਤੇ ਫ਼ੋਨ →" },
  "home.orderNote": {
    en: "Order at your table — build your list and show it to your server.",
    hi: "टेबल पर ही ऑर्डर करें — अपनी लिस्ट बनाएँ और सर्वर को दिखाएँ।",
    pa: "ਟੇਬਲ 'ਤੇ ਹੀ ਆਰਡਰ ਕਰੋ — ਆਪਣੀ ਲਿਸਟ ਬਣਾਓ ਤੇ ਸਰਵਰ ਨੂੰ ਵਿਖਾਓ।",
  },
  "menu.title": { en: "Menu", hi: "मेन्यू", pa: "ਮੀਨੂ" },
  "menu.search": { en: "Search butter chicken, naan, goat…", hi: "बटर चिकन, नान, गोट खोजें…", pa: "ਬਟਰ ਚਿਕਨ, ਨਾਨ, ਗੋਟ ਖੋਜੋ…" },
  "menu.flavour": { en: "Flavour filters", hi: "स्वाद फ़िल्टर", pa: "ਸੁਆਦ ਫਿਲਟਰ" },
  "menu.dishes": { en: "dishes", hi: "डिशेज़", pa: "ਡਿਸ਼ਾਂ" },
  "menu.dishOne": { en: "dish", hi: "डिश", pa: "ਡਿਸ਼" },
  "menu.add": { en: "ADD", hi: "जोड़ें", pa: "ਜੋੜੋ" },
  "menu.viewStory": { en: "VIEW STORY", hi: "कहानी देखें", pa: "ਕਹਾਣੀ ਵੇਖੋ" },
  "menu.order": { en: "ORDER", hi: "ऑर्डर", pa: "ਆਰਡਰ" },
  "menu.askKicker": { en: "NOT SURE WHAT TO ORDER?", hi: "समझ नहीं आ रहा क्या ऑर्डर करें?", pa: "ਸਮਝ ਨਹੀਂ ਆ ਰਿਹਾ ਕੀ ਆਰਡਰ ਕਰੀਏ?" },
  "menu.askDesc": {
    en: "Tell VeerGi your craving in English, हिंदी or ਪੰਜਾਬੀ and get a personal recommendation.",
    hi: "अपनी पसंद VeerGi को बताएँ — English, हिंदी या ਪੰਜਾਬੀ में — और पर्सनल सुझाव पाएँ।",
    pa: "ਆਪਣੀ ਪਸੰਦ VeerGi ਨੂੰ ਦੱਸੋ — English, हिंदी ਜਾਂ ਪੰਜਾਬੀ ਵਿੱਚ — ਤੇ ਨਿੱਜੀ ਸੁਝਾਅ ਲਓ।",
  },
  "menu.empty": {
    en: "Nothing matches — try another category or remove a filter.",
    hi: "कुछ नहीं मिला — दूसरी कैटेगरी देखें या फ़िल्टर हटाएँ।",
    pa: "ਕੁਝ ਨਹੀਂ ਮਿਲਿਆ — ਹੋਰ ਕੈਟਾਗਰੀ ਵੇਖੋ ਜਾਂ ਫਿਲਟਰ ਹਟਾਓ।",
  },
  "dish.addToList": { en: "ADD TO ORDER LIST", hi: "ऑर्डर लिस्ट में जोड़ें", pa: "ਆਰਡਰ ਲਿਸਟ ਵਿੱਚ ਜੋੜੋ" },
  "dish.myList": { en: "MY ORDER LIST", hi: "मेरी ऑर्डर लिस्ट", pa: "ਮੇਰੀ ਆਰਡਰ ਲਿਸਟ" },
  "dish.tasteKicker": { en: "Quick taste", hi: "झटपट स्वाद", pa: "ਝਟਪਟ ਸੁਆਦ" },
  "dish.tasteTitle": { en: "The taste profile", hi: "स्वाद प्रोफ़ाइल", pa: "ਸੁਆਦ ਪ੍ਰੋਫ਼ਾਈਲ" },
  "dish.storyKicker": { en: "Food story", hi: "खाने की कहानी", pa: "ਖਾਣੇ ਦੀ ਕਹਾਣੀ" },
  "dish.storyTitle": { en: "The story behind this dish", hi: "इस डिश के पीछे की कहानी", pa: "ਇਸ ਡਿਸ਼ ਪਿੱਛੇ ਦੀ ਕਹਾਣੀ" },
  "dish.listen": { en: "LISTEN TO THE STORY", hi: "कहानी सुनें", pa: "ਕਹਾਣੀ ਸੁਣੋ" },
  "dish.stop": { en: "STOP", hi: "रोकें", pa: "ਰੋਕੋ" },
  "dish.preparing": { en: "PREPARING…", hi: "तैयार हो रहा…", pa: "ਤਿਆਰ ਹੋ ਰਿਹਾ…" },
  "dish.quizKicker": { en: "Optional — play if you like", hi: "चाहें तो खेलें", pa: "ਚਾਹੋ ਤਾਂ ਖੇਡੋ" },
  "dish.quizTitle": { en: "Take the challenge", hi: "चैलेंज लें", pa: "ਚੈਲੰਜ ਲਓ" },
  "dish.pairKicker": { en: "Best pairings", hi: "बेहतरीन जोड़ियाँ", pa: "ਵਧੀਆ ਜੋੜੀਆਂ" },
  "dish.pairTitle": { en: "VeerGi's complete meal", hi: "VeerGi की पूरी थाली", pa: "VeerGi ਦੀ ਪੂਰੀ ਥਾਲੀ" },
  "dish.addMeal": { en: "ADD MEAL TO ORDER LIST", hi: "पूरी मील लिस्ट में जोड़ें", pa: "ਪੂਰਾ ਮੀਲ ਲਿਸਟ ਵਿੱਚ ਜੋੜੋ" },
  "dish.relatedKicker": { en: "You may also like", hi: "आपको ये भी पसंद आएँगे", pa: "ਤੁਹਾਨੂੰ ਇਹ ਵੀ ਪਸੰਦ ਆਉਣਗੇ" },
  "dish.relatedTitle": { en: "Similar dishes", hi: "मिलती-जुलती डिशेज़", pa: "ਮਿਲਦੀਆਂ-ਜੁਲਦੀਆਂ ਡਿਸ਼ਾਂ" },
  "dish.total": { en: "TOTAL", hi: "कुल", pa: "ਕੁੱਲ" },
  "rate.kicker": { en: "TRIED IT? ONE-TAP VERDICT", hi: "चखा? एक टैप में बताएँ", pa: "ਚੱਖਿਆ? ਇੱਕ ਟੈਪ ਵਿੱਚ ਦੱਸੋ" },
  "rate.change": { en: "YOUR VERDICT — TAP TO CHANGE", hi: "आपकी राय — बदलने के लिए टैप करें", pa: "ਤੁਹਾਡੀ ਰਾਏ — ਬਦਲਣ ਲਈ ਟੈਪ ਕਰੋ" },
  "rate.loved": { en: "LOVED IT", hi: "बहुत पसंद आया", pa: "ਬਹੁਤ ਪਸੰਦ ਆਇਆ" },
  "rate.good": { en: "GOOD", hi: "अच्छा", pa: "ਚੰਗਾ" },
  "rate.meh": { en: "NOT FOR ME", hi: "मेरे लिए नहीं", pa: "ਮੇਰੇ ਲਈ ਨਹੀਂ" },
  "order.kicker": { en: "YOUR ORDER LIST", hi: "आपकी ऑर्डर लिस्ट", pa: "ਤੁਹਾਡੀ ਆਰਡਰ ਲਿਸਟ" },
  "order.showServer": { en: "Show this to your server", hi: "यह अपने सर्वर को दिखाएँ", pa: "ਇਹ ਆਪਣੇ ਸਰਵਰ ਨੂੰ ਵਿਖਾਓ" },
  "order.sub": {
    en: "Your server will take it from here — no payment happens on this tablet.",
    hi: "आगे का काम सर्वर संभालेगा — इस टैबलेट पर कोई पेमेंट नहीं होती।",
    pa: "ਅੱਗੇ ਦਾ ਕੰਮ ਸਰਵਰ ਸੰਭਾਲੇਗਾ — ਇਸ ਟੈਬਲੇਟ 'ਤੇ ਕੋਈ ਪੇਮੈਂਟ ਨਹੀਂ ਹੁੰਦੀ।",
  },
  "order.emptyTitle": { en: "Nothing on your list yet", hi: "अभी लिस्ट खाली है", pa: "ਹਾਲੇ ਲਿਸਟ ਖਾਲੀ ਹੈ" },
  "order.emptyDesc": {
    en: "Tap ADD TO ORDER LIST on any dish — then show this list to your server when they come to the table.",
    hi: "किसी भी डिश पर \"ऑर्डर लिस्ट में जोड़ें\" दबाएँ — फिर सर्वर आए तो यह लिस्ट दिखाएँ।",
    pa: "ਕਿਸੇ ਵੀ ਡਿਸ਼ 'ਤੇ \"ਆਰਡਰ ਲਿਸਟ ਵਿੱਚ ਜੋੜੋ\" ਦਬਾਓ — ਫਿਰ ਸਰਵਰ ਆਵੇ ਤਾਂ ਇਹ ਲਿਸਟ ਵਿਖਾਓ।",
  },
  "order.clear": { en: "CLEAR LIST", hi: "लिस्ट खाली करें", pa: "ਲਿਸਟ ਖਾਲੀ ਕਰੋ" },
  "order.done": { en: "DONE — I'LL SHOW MY SERVER", hi: "हो गया — सर्वर को दिखाऊँगा", pa: "ਹੋ ਗਿਆ — ਸਰਵਰ ਨੂੰ ਵਿਖਾਵਾਂਗਾ" },
  "order.keep": { en: "KEEP EXPLORING", hi: "और देखें", pa: "ਹੋਰ ਵੇਖੋ" },
  "rate.thanks": {
    en: "Shukriya! Your verdict goes straight to the kitchen.",
    hi: "शुक्रिया! आपकी राय सीधे किचन तक जाती है।",
    pa: "ਸ਼ੁਕਰੀਆ! ਤੁਹਾਡੀ ਰਾਏ ਸਿੱਧੀ ਰਸੋਈ ਤੱਕ ਜਾਂਦੀ ਹੈ।",
  },
  "rate.placeholder": { en: "Tell the kitchen why (optional)", hi: "किचन को वजह बताएँ (ऐच्छिक)", pa: "ਰਸੋਈ ਨੂੰ ਵਜ੍ਹਾ ਦੱਸੋ (ਵਿਕਲਪਿਕ)" },
  "rate.send": { en: "SEND", hi: "भेजें", pa: "ਭੇਜੋ" },
  "rate.privacy": {
    en: "Private — goes only to the kitchen, never shown to other guests.",
    hi: "निजी — सिर्फ़ किचन तक जाती है, दूसरे मेहमानों को कभी नहीं दिखती।",
    pa: "ਨਿੱਜੀ — ਸਿਰਫ਼ ਰਸੋਈ ਤੱਕ ਜਾਂਦੀ ਹੈ, ਹੋਰ ਮਹਿਮਾਨਾਂ ਨੂੰ ਕਦੇ ਨਹੀਂ ਦਿਸਦੀ।",
  },
  "rate.noteSent": { en: "Note sent to the kitchen — shukriya ji!", hi: "नोट किचन को भेज दिया — शुक्रिया जी!", pa: "ਨੋਟ ਰਸੋਈ ਨੂੰ ਭੇਜ ਦਿੱਤਾ — ਸ਼ੁਕਰੀਆ ਜੀ!" },
  "rate.review": {
    en: "LOVED IT? TELL THE WORLD — GOOGLE REVIEW",
    hi: "पसंद आया? दुनिया को बताएँ — GOOGLE रिव्यू",
    pa: "ਪਸੰਦ ਆਇਆ? ਦੁਨੀਆ ਨੂੰ ਦੱਸੋ — GOOGLE ਰਿਵਿਊ",
  },
  "mascot.greet": {
    en: "Sat Sri Akal ji! I'm VeerGi — tap me anytime and I'll tell you about our food.",
    hi: "सत श्री अकाल जी! मैं VeerGi हूँ — कभी भी टैप करें, मैं आपको हमारे खाने के बारे में बताऊँगा।",
    pa: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ ਜੀ! ਮੈਂ VeerGi ਹਾਂ — ਕਦੇ ਵੀ ਟੈਪ ਕਰੋ, ਮੈਂ ਤੁਹਾਨੂੰ ਸਾਡੇ ਖਾਣੇ ਬਾਰੇ ਦੱਸਾਂਗਾ।",
  },
  "mascot.dishAdded": {
    en: "Wah ji wah — great pick! It's on your order list.",
    hi: "वाह जी वाह — बढ़िया चुनाव! आपकी ऑर्डर लिस्ट में जुड़ गया।",
    pa: "ਵਾਹ ਜੀ ਵਾਹ — ਵਧੀਆ ਚੋਣ! ਤੁਹਾਡੀ ਆਰਡਰ ਲਿਸਟ ਵਿੱਚ ਜੁੜ ਗਿਆ।",
  },
  "mascot.reward": {
    en: "Badhai ho! Reward unlocked — show the code to your server.",
    hi: "बधाई हो! इनाम मिल गया — कोड अपने सर्वर को दिखाएँ।",
    pa: "ਵਧਾਈਆਂ! ਇਨਾਮ ਮਿਲ ਗਿਆ — ਕੋਡ ਆਪਣੇ ਸਰਵਰ ਨੂੰ ਵਿਖਾਓ।",
  },
  "mascot.quizCorrect": {
    en: "Shabash! You know your Punjabi food.",
    hi: "शाबाश! आपको पंजाबी खाने की समझ है।",
    pa: "ਸ਼ਾਬਾਸ਼! ਤੁਹਾਨੂੰ ਪੰਜਾਬੀ ਖਾਣੇ ਦੀ ਸਮਝ ਹੈ।",
  },
  "mascot.levelDone": {
    en: "Kamaal ji! You finished a whole quiz level — a true Punjab expert!",
    hi: "कमाल जी! आपने पूरा क्विज़ लेवल पूरा किया — सच्चे पंजाब एक्सपर्ट!",
    pa: "ਕਮਾਲ ਜੀ! ਤੁਸੀਂ ਪੂਰਾ ਕੁਇਜ਼ ਲੈਵਲ ਪੂਰਾ ਕੀਤਾ — ਸੱਚੇ ਪੰਜਾਬ ਐਕਸਪਰਟ!",
  },
  "mascot.champion": {
    en: "Badhai ho, Champion! You topped this week's quiz board!",
    hi: "बधाई हो, चैंपियन! आप इस हफ़्ते के क्विज़ बोर्ड में सबसे ऊपर हैं!",
    pa: "ਵਧਾਈਆਂ, ਚੈਂਪੀਅਨ! ਤੁਸੀਂ ਇਸ ਹਫ਼ਤੇ ਦੇ ਕੁਇਜ਼ ਬੋਰਡ ਵਿੱਚ ਸਭ ਤੋਂ ਉੱਪਰ ਹੋ!",
  },
  "mascot.hear": { en: "HEAR VEERGI", hi: "VeerGi को सुनें", pa: "VeerGi ਨੂੰ ਸੁਣੋ" },
  "story.live": { en: "BRING THIS STORY TO LIFE", hi: "इस कहानी को जीवंत करें", pa: "ਇਸ ਕਹਾਣੀ ਨੂੰ ਜੀਵੰਤ ਕਰੋ" },
  "story.liveSub": {
    en: "A 40-second journey with narration — meet the dish",
    hi: "40 सेकंड का सफ़र, आवाज़ के साथ — डिश से मिलिए",
    pa: "40 ਸਕਿੰਟ ਦਾ ਸਫ਼ਰ, ਆਵਾਜ਼ ਨਾਲ — ਡਿਸ਼ ਨੂੰ ਮਿਲੋ",
  },
  "mascot.mute": { en: "MUTE", hi: "म्यूट", pa: "ਮਿਊਟ" },
  "mascot.unmute": { en: "UNMUTE", hi: "आवाज़ चालू", pa: "ਆਵਾਜ਼ ਚਾਲੂ" },
  "mascot.hide": { en: "HIDE", hi: "छिपाएँ", pa: "ਲੁਕਾਓ" },
  "quiz.l1": { en: "LEARN", hi: "सीखें", pa: "ਸਿੱਖੋ" },
  "quiz.l2": { en: "UNDERSTAND", hi: "समझें", pa: "ਸਮਝੋ" },
  "quiz.l3": { en: "TASTE & EXPERT", hi: "स्वाद और एक्सपर्ट", pa: "ਸੁਆਦ ਤੇ ਐਕਸਪਰਟ" },
  "quiz.done": { en: "COMPLETED", hi: "पूरा हुआ", pa: "ਪੂਰਾ ਹੋਇਆ" },
  "quiz.lockedDesc": {
    en: "Order first — or ask your server for today's code.",
    hi: "पहले ऑर्डर करें — या आज का कोड अपने सर्वर से पूछें।",
    pa: "ਪਹਿਲਾਂ ਆਰਡਰ ਕਰੋ — ਜਾਂ ਅੱਜ ਦਾ ਕੋਡ ਆਪਣੇ ਸਰਵਰ ਤੋਂ ਪੁੱਛੋ।",
  },
  "quiz.unlock": { en: "UNLOCK", hi: "अनलॉक", pa: "ਅਨਲੌਕ" },
  "quiz.codePlaceholder": { en: "Staff code", hi: "स्टाफ़ कोड", pa: "ਸਟਾਫ ਕੋਡ" },
  "quiz.wrongCode": { en: "Wrong code — ask your server.", hi: "गलत कोड — सर्वर से पूछें।", pa: "ਗਲਤ ਕੋਡ — ਸਰਵਰ ਤੋਂ ਪੁੱਛੋ।" },
  "quiz.correct": { en: "Shabash! That's right.", hi: "शाबाश! सही जवाब।", pa: "ਸ਼ਾਬਾਸ਼! ਸਹੀ ਜਵਾਬ।" },
  "quiz.wrong": { en: "Not quite — but now you know.", hi: "सही नहीं — पर अब आप जान गए।", pa: "ਸਹੀ ਨਹੀਂ — ਪਰ ਹੁਣ ਤੁਸੀਂ ਜਾਣ ਗਏ।" },
  "quiz.already": { en: "Already earned.", hi: "पहले ही कमा चुके।", pa: "ਪਹਿਲਾਂ ਹੀ ਕਮਾ ਚੁੱਕੇ।" },
  "quiz.monthLocked": {
    en: "Already counted this month — points reset monthly.",
    hi: "इस महीने गिना जा चुका — पॉइंट्स हर महीने रीसेट होते हैं।",
    pa: "ਇਸ ਮਹੀਨੇ ਗਿਣਿਆ ਜਾ ਚੁੱਕਾ — ਪੁਆਇੰਟ ਹਰ ਮਹੀਨੇ ਰੀਸੈੱਟ ਹੁੰਦੇ ਹਨ।",
  },
  "quizRules.title": { en: "HOW THE POINTS GAME WORKS", hi: "पॉइंट्स गेम कैसे चलता है", pa: "ਪੁਆਇੰਟ ਗੇਮ ਕਿਵੇਂ ਚੱਲਦੀ ਹੈ" },
  "quizRules.r1": { en: "every correct answer (Levels 1 & 2)", hi: "हर सही जवाब (लेवल 1 और 2)", pa: "ਹਰ ਸਹੀ ਜਵਾਬ (ਲੈਵਲ 1 ਅਤੇ 2)" },
  "quizRules.r2": { en: "the final expert question (Level 3)", hi: "आख़िरी एक्सपर्ट सवाल (लेवल 3)", pa: "ਆਖਰੀ ਐਕਸਪਰਟ ਸਵਾਲ (ਲੈਵਲ 3)" },
  "quizRules.r3": { en: "a wrong guess — but never below zero", hi: "गलत जवाब — पर कभी शून्य से नीचे नहीं", pa: "ਗਲਤ ਜਵਾਬ — ਪਰ ਕਦੇ ਜ਼ੀਰੋ ਤੋਂ ਹੇਠਾਂ ਨਹੀਂ" },
  "quizRules.r4": {
    en: "Each question counts once a month — fresh points every month!",
    hi: "हर सवाल महीने में एक बार गिना जाता है — हर महीने नए पॉइंट्स!",
    pa: "ਹਰ ਸਵਾਲ ਮਹੀਨੇ ਵਿੱਚ ਇੱਕ ਵਾਰ ਗਿਣਿਆ ਜਾਂਦਾ ਹੈ — ਹਰ ਮਹੀਨੇ ਨਵੇਂ ਪੁਆਇੰਟ!",
  },
  "quizRules.cta": { en: "GOT IT — LET'S PLAY", hi: "समझ गया — चलो खेलें", pa: "ਸਮਝ ਗਿਆ — ਚਲੋ ਖੇਡੀਏ" },
  "quizRules.open": { en: "HOW POINTS WORK", hi: "पॉइंट्स कैसे मिलते हैं", pa: "ਪੁਆਇੰਟ ਕਿਵੇਂ ਮਿਲਦੇ ਹਨ" },
  "quiz.capped": {
    en: "Come back tomorrow for more points!",
    hi: "और पॉइंट्स के लिए कल फिर आएँ!",
    pa: "ਹੋਰ ਪੁਆਇੰਟਾਂ ਲਈ ਕੱਲ੍ਹ ਫਿਰ ਆਓ!",
  },
  "quiz.next": { en: "NEXT QUESTION", hi: "अगला सवाल", pa: "ਅਗਲਾ ਸਵਾਲ" },
  "passport.expiring": {
    en: "Expiring soon — visit us to keep your points alive!",
    hi: "जल्द एक्सपायर होंगे — पॉइंट्स बचाने के लिए हमसे मिलने आएँ!",
    pa: "ਜਲਦ ਐਕਸਪਾਇਰ ਹੋਣਗੇ — ਪੁਆਇੰਟ ਬਚਾਉਣ ਲਈ ਸਾਨੂੰ ਮਿਲਣ ਆਓ!",
  },
};

const CAT_I18N = {
  "Popular": { hi: "लोकप्रिय", pa: "ਹਰਮਨਪਿਆਰੇ" },
  "Starters": { hi: "स्टार्टर्स", pa: "ਸਟਾਰਟਰ" },
  "Chaat & Street Food": { hi: "चाट और स्ट्रीट फ़ूड", pa: "ਚਾਟ ਤੇ ਸਟ੍ਰੀਟ ਫੂਡ" },
  "Tandoor & Grill": { hi: "तंदूर और ग्रिल", pa: "ਤੰਦੂਰ ਤੇ ਗ੍ਰਿੱਲ" },
  "Chicken": { hi: "चिकन", pa: "ਚਿਕਨ" },
  "Lamb & Goat": { hi: "लैम्ब और गोट", pa: "ਲੈਂਬ ਤੇ ਗੋਟ" },
  "Vegetarian": { hi: "शाकाहारी", pa: "ਸ਼ਾਕਾਹਾਰੀ" },
  "Rice & Biryani": { hi: "चावल और बिरयानी", pa: "ਚੌਲ ਤੇ ਬਿਰਯਾਨੀ" },
  "Breads": { hi: "रोटियाँ और नान", pa: "ਰੋਟੀਆਂ ਤੇ ਨਾਨ" },
  "Urban Express": { hi: "Urban Express", pa: "Urban Express" },
  "Desserts": { hi: "मिठाइयाँ", pa: "ਮਿਠਾਈਆਂ" },
  "Drinks": { hi: "ड्रिंक्स", pa: "ਡ੍ਰਿੰਕਸ" },
};

const LangContext = createContext({ lang: "en", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    // hi/pa paused for now — voice quality rejected by owner; English only until a better TTS is found
    const v = localStorage.getItem("xp_lang") || "en";
    if (v !== "en") {
      localStorage.setItem("xp_lang", "en");
      return "en";
    }
    return v;
  });
  const setLang = useCallback((v) => {
    localStorage.setItem("xp_lang", v);
    document.documentElement.lang = v;
    setLangState(v);
  }, []);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const useT = () => {
  const { lang } = useLang();
  return (key) => STR[key]?.[lang] || STR[key]?.en || key;
};

export const tCat = (lang, cat) => (lang === "en" ? cat : CAT_I18N[cat]?.[lang] || cat);

export const dishDesc = (dish, lang) =>
  (lang === "hi" && dish.description_hi) || (lang === "pa" && dish.description_pa) || dish.description;
